import { TMfaSessionsResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { MobileRun } from 'src/apps/dashboard/types/MobileRunsTableTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MobileDashboardMfaSessionsQuery } from '../MfaSessions.generated';

export const transformMfaSessionsResults = (
	rawResults: MobileDashboardMfaSessionsQuery
): TMfaSessionsResult => {
	const rows: MobileRun[] =
		rawResults.mfa_session_runs?.filter(returnNonNull).map((session) => ({
			id: session.run_id,
			name: session.session_name,
			totalIssues: session.total_issues,
			criticalIssues: session.critical_issues,
			date: session.run_updated_at,
			detailsUrl: session.run_id
				? RoutesHelper.getMfaSessionPath(session.run_id, SessionViews.OVERVIEW)
				: undefined
		})) ?? [];

	const total = rawResults.total?.[0]?.run_id_count ?? 0;
	const unfilteredTotal = rawResults.unfiltered_total?.[0]?.run_id_count ?? 0;

	return {
		rows,
		total,
		unfilteredTotal
	};
};
